import { useDemandeProformaStore } from '@/features/interface/demande/proforma/useDemandeProformaStore.ts'
import { computed, type InjectionKey } from 'vue'
import { buildDemandeActions } from '../shared'

export type DemandeProformaActions = ReturnType<typeof useDemandeProformaActions>
export const PROFORMA_ACTIONS: InjectionKey<DemandeProformaActions> = Symbol('demande-inject')

export function useDemandeProformaActions() {
  const store = useDemandeProformaStore()
  // const { model } = storeToRefs(store)

  const actionsDemande = buildDemandeActions({
    store: store as any,
    typeDocumentTemplate: computed(() => 'ProForma'),
  })

  return {
    ...actionsDemande,
  }
}
